export default {
  title: 'Travlhedstilstand',
  form: {
    has_busy_mode: {
      label: 'Travlhedstilstand',
    },
    busy_mode_minutes: {
      label: 'Hvor meget tid skal lægges til din normale tilberedningstid?',
      options: {
        10: '10 min.',
        15: '15 min.',
        20: '20 min.',
        25: '25 min.',
        30: '30 min.',
        45: '45 min.',
        60: '1 time',
      },
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
